import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormValidatorService } from 'src/app/shared/form_Validation/form-validator.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VerificationPopupComponent } from '../shared/popups/verification-popup/verification-popup.component';
import { BACKEND, client_id, idme_url } from '../../config';

@Component({
  selector: 'app-identity-verification',
  templateUrl: './identity-verification.component.html',
  styleUrls: ['./identity-verification.component.css']
})
export class IdentityVerificationComponent implements OnInit {
  search_input: FormGroup;
  UserData: any;
  code: any;
  callBack = false;
  constructor(
    private route: ActivatedRoute
    , private router: Router
    , private Formvalidator: FormValidatorService
    , private formBuilder: FormBuilder
    , private _apiService: ApiService
    , private cookieService: CookieService
    , private spinner: NgxSpinnerService
    , private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
  ) {
    this.search_input = this.formBuilder.group({
      user_email: new FormControl('', [Validators.required]),
        first_name: new FormControl('', [Validators.required]),
        last_name: ['', Validators.required],
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.code = params['code'];
      if ( params['code']) {
        this.spinner.show();

          this.getIdMe();

          // this.router.navigate(['/verification']);
      } else {

      }
  });
  }
  openPopUP() {
    const dialogRef = this.dialog.open(VerificationPopupComponent, {
    });
  }
  getIdMe() {
    // const data = {code: this.code};
    const formdata = new FormData();
    // formdata.append('code', this.code);
    //
    const data = {code: this.code};
    this._apiService.functionPOST('integrations/id_me/getData' , data).subscribe((response) => {
      if (response['success']) {
        this.spinner.hide();
        this._apiService.openSnackBar('ID.me account verified', 'success');
        this.callBack = true;
        this.getUserDetails(this.callBack);

      }

    }, err => {
      this.spinner.hide();
      this._apiService.openSnackBar('ID.me verification failed', 'Error');
      this.router.navigate([], { replaceUrl: true});
    });
  }

  ngOnInit() {
    this.getUserDetails();
  }
  // backToLogin(){
  //    this.router.navigate(['/']);
  //   this.cookieService.deleteAll('/');
  // }
  getUserDetails(callBack?) {
    this._apiService.functionGET('user/getUserDetailsForEdit' ).subscribe((response) => {
      this.UserData = response.data.userData;
      this.search_input.patchValue({
        first_name : this.UserData.firstname,
        last_name : this.UserData.lastname,
        user_email : this.UserData.email
      });
    if (callBack) {
      // if (!this.UserData.kyc_pass) {
      //   this.router.navigate(['/pending_approval']);
      // } else {
         if (!this.UserData.kyc_pass) {
        this.router.navigate(['/current_business']);
      } else {
        this.router.navigate(['/dashboard/task-management']);
      }

    }
    },
    err => {

    });
  }
  openIDme() {
    window.location.href = '' + idme_url + '/oauth/authorize?client_id=' + client_id + '&redirect_uri=' +
     BACKEND + 'user/idmeAuth&response_type=code&scope=authentication&state=488e864b\\';
  }

}

